import axios from "axios";
import { ICollectionConfigManifest } from "pages/Explore/types";
import { QueryFunctionContext, useQuery } from "react-query";
import { IStacCollection } from "types/stac";
import { STAC_URL, API_VERSION } from "utils/constants";
import { QUERY_KEYS } from "utils/requests";

export const useCollectionConfigManifest = (collectionId: string | undefined) => {
  return useQuery(
    [QUERY_KEYS.configManifest, collectionId],
    getCollectionConfigManifest,
    {
      enabled: Boolean(collectionId),
    }
  );
};

const getCollectionConfigManifest = async (
  queryContext: QueryFunctionContext<[string, string | undefined]>
): Promise<ICollectionConfigManifest> => {
  const [, collectionId] = queryContext.queryKey;
  return await fetchCollectionConfigManifest(collectionId);
};

export const fetchCollectionConfigManifest = async (
  collectionId: string | undefined
): Promise<ICollectionConfigManifest> => {
  const collectionConfig: ICollectionConfigManifest = await (
    await axios.get(`${STAC_URL}/collections/${collectionId}/configurations`, {
      params: { "api-version": API_VERSION },
    })
  ).data;
  return collectionConfig;
};

export const fetchCollection = async (
  collectionId: string
): Promise<IStacCollection> => {
  return await (
    await axios.get(`${STAC_URL}/collections/${collectionId}`, {
      params: { "api-version": API_VERSION },
    })
  ).data;
};
